import { Component } from '@poa/core';
import React from 'react';
import { GRANTED_HOSTS } from '../../store/auth/auth.constants';

class ExternalLinkContextMenu extends React.Component {
  store;

  render() {
    const { url, label, styles } = this.props;
    let content = null;

    switch (this.store.auth.currentHost) {
      case GRANTED_HOSTS.nc:
        content = (
          <a
            href={`http://www.natashaclub.com/profile.php?ID=${url}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {label || 'NC'}
          </a>
        );
        break;
      case GRANTED_HOSTS.dm:
        content = (
          <a
            href={`https://www.dream-singles.com/${url}.html`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {label || 'DM'}
          </a>
        );
        break;
      case GRANTED_HOSTS.pd:
        content = (
          <a
            href={`https://datame.cloud/profile-trusted/${url}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {label || 'PD'}
          </a>
        );
        break;
      case GRANTED_HOSTS.of:
        content = label;
        break;
      default:
        break;
    }

    return (
      <div
        className="links"
        style={styles || { textAlign: 'left', fontSize: '12px', marginTop: '15px' }}
      >
        {content}
      </div>
    );
  }
}

export default Component()(ExternalLinkContextMenu);
